// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Pe-z","heading":"Qe-z"};